module.exports = __webpack_public_path__ + "static/img/1064_phase_function_Paper_PointsHejduk_Prediction.db872a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1064_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cez+
// module chunks = 0